export default __webpack_public_path__ + "static/media/MountainSlopesMap.465f39cb.jpg";